import React from 'react';

interface ToggleButtonProps extends React.InputHTMLAttributes<HTMLInputElement> {
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
  className?: string;
}

export const ToggleButton: React.FC<ToggleButtonProps> = ({
  checked,
  onChange,
  label,
  className = '',
  ...props
}) => (
  <label className={`flex items-center space-x-3 cursor-pointer select-none ${className}`}>
    <span className="relative inline-block w-12 h-6 align-middle">
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className="absolute w-full h-full opacity-0 cursor-pointer z-10 m-0"
        {...props}
      />
      <span
        className={`block w-12 h-6 rounded-full transition-colors duration-200 ${checked ? 'bg-primary' : 'bg-[#E1E9F0]'}`}
      ></span>
      <span
        className={`absolute left-0 top-0 w-6 h-6 bg-white rounded-full shadow transition-transform duration-200 ${checked ? 'translate-x-6' : ''}`}
        style={{ boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.10)' }}
      ></span>
    </span>
    <span className="font-ambit text-[0.9375rem] not-italic leading-[1.25rem] text-secondary">
      {label}
    </span>
  </label>
);
